import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHigh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.06117 2.13507C10.8136 0.86195 13.1864 0.86195 14.9388 2.13507L21.0609 6.58278C22.8134 7.856 23.5467 10.1129 22.8773 12.1731L20.5386 19.3705C19.8692 21.4305 17.9494 22.8253 15.7833 22.8253H8.21669C6.0506 22.8253 4.13084 21.4305 3.46144 19.3705L1.1227 12.1731C0.453257 10.1129 1.18659 7.856 2.93912 6.58278L9.06117 2.13507Z",
		fill: "#FF6D00"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 16.4026C12.6969 16.4026 13.2618 16.9675 13.2618 17.6643C13.2618 18.3612 12.6969 18.9261 12 18.9261C11.3032 18.9261 10.7383 18.3612 10.7383 17.6643C10.7383 16.9675 11.3032 16.4026 12 16.4026ZM12 6.30859C12.6908 6.30859 13.245 6.87933 13.2247 7.5698L13.0314 14.1393C13.015 14.6971 12.5581 15.1408 12 15.1408C11.442 15.1408 10.985 14.6971 10.9686 14.1393L10.7754 7.56979C10.7551 6.87933 11.3093 6.30859 12 6.30859Z",
		fill: "white"
	})]
});
export default SvgHigh;
